/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_IntroInputs */

const en_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every lesson is one-on-one with Mark. No assistants, no group classes. Just the focused attention that produces real results.`)
};

const es_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada lección es uno a uno con Mark. Sin asistentes, sin clases grupales. Solo la atención personalizada que da resultados de verdad.`)
};

const de_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Unterrichtsstunde ist Einzelunterricht mit Mark. Keine Assistenten, kein Gruppenunterricht. Nur die gezielte Aufmerksamkeit, die echte Ergebnisse hervorbringt.`)
};

const zh_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每节课都是与 Mark 一对一的。没有助理，没有小组课程。只有集中注意力才能产生真正的结果。`)
};

const ar_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل درس فردي مع Mark. بلا مساعدين، بلا صفوف جماعية. فقط الاهتمام المركّز الذي يحقّق نتائج حقيقية.`)
};

const fr_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque leçon est individuelle avec Mark. Pas d'assistants, pas de cours collectifs. Juste l’attention concentrée qui produit de vrais résultats.`)
};

const vi_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi bài học là một kèm một với Mark. Không trợ giảng, không lớp nhóm. Chỉ sự chú ý tập trung tạo ra kết quả thực.`)
};

const sw_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kila somo ni la mtu mmoja na Mark. Hakuna wasaidizi, hakuna madarasa ya vikundi. Ni umakini kamili tu unaoleta matokeo halisi.`)
};

const th_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกบทเรียนเป็นแบบตัวต่อตัวกับ Mark ไม่มีผู้ช่วย ไม่มีชั้นเรียนแบบกลุ่ม เพียงการเอาใจใส่ที่มุ่งเน้นซึ่งก่อให้เกิดผลลัพธ์ที่แท้จริง`)
};

const bs_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svaka lekcija je individualna s Markom. Bez asistenata, bez grupnih časova. Samo fokusirana pažnja koja daje stvarne rezultate.`)
};

const ja_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのレッスンはMarkとのマンツーマンです。アシスタントもグループクラスもありません。確かな結果を生む、集中した指導だけです。`)
};

const ko_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 레슨은 Mark와 1:1로 진행됩니다. 보조 강사도, 그룹 수업도 없습니다. 실제 성과로 이어지는 집중적인 지도만 있을 뿐입니다.`)
};

const pt_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as aulas são individuais com o Mark. Sem assistentes, sem aulas em grupo. Apenas a atenção dedicada que produz resultados reais.`)
};

const it_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni lezione è individuale, solo tu e Mark. Niente assistenti, niente lezioni di gruppo. Solo un’attenzione mirata che porta risultati concreti.`)
};

const sv_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje lektion är en-till-en med Mark. Inga assistenter, inga gruppklasser. Bara den fokuserade uppmärksamheten som ger verkliga resultat.`)
};

const nl_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke les is één op één met Mark. Geen assistenten, geen groepslessen. Alleen de aandacht die echte resultaten oplevert.`)
};

const da_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver lektion er en-til-en med Mark. Ingen assistenter, ingen gruppehold. Kun den fokuserede opmærksomhed, der giver reelle resultater.`)
};

const nb_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver leksjon er én-til-én med Mark. Ingen assistenter, ingen gruppetimer. Bare den fokuserte oppmerksomheten som gir reelle resultater.`)
};

const fi_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen oppitunti on kahdenkeskinen Markin kanssa. Ei avustajia, ei ryhmäkursseja. Vain keskittynyt huomio, joka tuottaa todellisia tuloksia.`)
};

const pl_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda lekcja to zajęcia jeden na jeden z Markiem. Żadnych asystentów, żadnych zajęć grupowych. Tylko pełna uwaga, która przynosi prawdziwe efekty.`)
};

const ru_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый урок проходит один на один с тренером Mark. Никаких ассистентов и групповых занятий — только сосредоточенная работа, которая даёт реальные результаты.`)
};

const tr_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ders Mark ile birebir. Asistan yok, grup dersi yok. Sadece gerçek sonuçlar getiren odaklı ilgi.`)
};

const hi_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हर पाठ Mark के साथ आमने-सामने होता है। न कोई सहायक, न कोई ग्रुप क्लास। सिर्फ़ केंद्रित निर्देशन, जो असली नतीजे देता है।`)
};

const id_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pelajaran bersifat privat bersama Mark. Tanpa asisten, tanpa kelas kelompok. Hanya perhatian penuh yang memberikan hasil nyata.`)
};

const ms_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pelajaran ialah sesi satu lawan satu bersama Mark. Tiada pembantu, tiada kelas berkumpulan. Hanya perhatian sepenuhnya yang menghasilkan keputusan sebenar.`)
};

const cs_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každá lekce je jedna na jednoho s Markem. Žádní asistenti, žádné skupinové hodiny. Jen pozornost, která přináší skutečné výsledky.`)
};

const el_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάθε μάθημα είναι ιδιαίτερο, ένας προς έναν με τον Mark. Χωρίς βοηθούς, χωρίς ομαδικά μαθήματα. Μόνο η απόλυτη προσοχή που φέρνει πραγματικά αποτελέσματα.`)
};

const he_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל שיעור הוא אחד על אחד עם Mark. לא עוזרים, אין קבוצות. רק תשומת הלב ממוקדת שמייצרת תוצאות אמיתיות.`)
};

const af_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke les is een-tot-een met Mark. Geen assistente, geen groepklasse nie. Net die gefokusde aandag wat werklike resultate lewer.`)
};

const hu_lessons_intro = /** @type {(inputs: Lessons_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden óra négyszemközti óra Markkal. Nincsenek asszisztensek, nincsenek csoportos órák. Csak az a teljes figyelem, amely valódi eredményeket hoz.`)
};

/**
* | output |
* | --- |
* | "Every lesson is one-on-one with Mark. No assistants, no group classes. Just the focused attention that produces real results." |
*
* @param {Lessons_IntroInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_intro = /** @type {((inputs?: Lessons_IntroInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_IntroInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_intro(inputs)
	if (locale === "de") return de_lessons_intro(inputs)
	if (locale === "zh") return zh_lessons_intro(inputs)
	if (locale === "ar") return ar_lessons_intro(inputs)
	if (locale === "fr") return fr_lessons_intro(inputs)
	if (locale === "vi") return vi_lessons_intro(inputs)
	if (locale === "sw") return sw_lessons_intro(inputs)
	if (locale === "th") return th_lessons_intro(inputs)
	if (locale === "bs") return bs_lessons_intro(inputs)
	if (locale === "ja") return ja_lessons_intro(inputs)
	if (locale === "ko") return ko_lessons_intro(inputs)
	if (locale === "pt") return pt_lessons_intro(inputs)
	if (locale === "it") return it_lessons_intro(inputs)
	if (locale === "sv") return sv_lessons_intro(inputs)
	if (locale === "nl") return nl_lessons_intro(inputs)
	if (locale === "da") return da_lessons_intro(inputs)
	if (locale === "nb") return nb_lessons_intro(inputs)
	if (locale === "fi") return fi_lessons_intro(inputs)
	if (locale === "pl") return pl_lessons_intro(inputs)
	if (locale === "ru") return ru_lessons_intro(inputs)
	if (locale === "tr") return tr_lessons_intro(inputs)
	if (locale === "hi") return hi_lessons_intro(inputs)
	if (locale === "id") return id_lessons_intro(inputs)
	if (locale === "ms") return ms_lessons_intro(inputs)
	if (locale === "cs") return cs_lessons_intro(inputs)
	if (locale === "el") return el_lessons_intro(inputs)
	if (locale === "he") return he_lessons_intro(inputs)
	if (locale === "af") return af_lessons_intro(inputs)
	if (locale === "hu") return hu_lessons_intro(inputs)
	return en_lessons_intro(inputs)
});